import { CancellationType } from "../../enums";
import { CancellationPerk } from "../../types";

export const possiblePerkFilter = (type: CancellationType) => (
  perk: CancellationPerk
) => (perk as any)[type.toLowerCase()] !== "false";

export const getMobilePerkValue = (type: CancellationType) => (
  perk: CancellationPerk
) => {
  const value = (perk as any)[type.toLowerCase()];
  return value && !["false", "true"].includes(value) ? value : undefined;
};
